<div [formGroup]='parent' class="form-field">
  <div class="alignPos mb-30">
    <span for="addressSearch"> {{question.questionText}}</span>
    @if (question.helpText) {
      <div class="info-icon d-view">
        <app-tool-tip-notification [childId]="'inputComp'" [tooltipData]="initializeToolTipDateComp(question)">
        </app-tool-tip-notification>
      </div>
    }
    @if (question.helpText) {
      <div class="info-icon mt-view">
        <app-tool-tip-notification [childId]="'inputComp'" [tooltipData]="initializeToolTipDateComp(question)"
          (displayMobileTooltipEmitter)="displayDrpTooltipMessage(question)">
        </app-tool-tip-notification>
        @if (displayTooltipAlert) {
          <app-modal [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
          (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
        }
      </div>
    }
  </div>
  <input class="form-control wd-300" [formControlName]="controlName" id="{{domId}}"
    [placeholder]="getPlaceholder()" type="text" [(ngModel)]="enteredValue" (blur)="checkInputValues()" (input)="Search()">

    @if (addressData.length > 0 && isMedicationObjectType) {
      <ul class="autofill wd-300">
        @for (item of addressData; track item; let i = $index) {
          <li [id]="item.subCondition" [(value)]="addressData[i].subCondition" (click)="onSelectOfSearchResultsAsObj(item, true)">
            {{item.subCondition}}
          </li>
        }
      </ul>
    }

    @if (addressData.length > 0 && !isMedicationObjectType) {
      <ul class="autofill wd-300">
        @for (item of addressData; track item; let i = $index) {
          <li [id]="item" [(value)]="addressData[i]" (click)="onSelectOfSearchResultsAsString(item, true)">
            {{item}}
          </li>
        }
      </ul>
    }
  </div>

  @if (parent.get(controlName).touched
    &&
    parent.get(controlName).errors) {
    <div  class="top-10 form-validation-error">
      <i class="icon icon-error" aria-hidden="true"></i>
      @if (parent.get(controlName).errors.required) {
        <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">Please enter the name of your {{getErrorMsgValue('required')}}</p>
      }
      @if (parent.get(controlName).errors.invalid) {
        <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">Please enter the name of your {{getErrorMsgValue('invalid')}}</p>
      }
      @if (parent.get(controlName).errors.invalidSelect) {
        <p [id]="pageName+'-'+controlName +'-error'" aria-hidden="false" role="error" aria-live="polite">Please select the name of your {{getErrorMsgValue('invalidSelect')}} from the list</p>
      }
    </div>
  }